export const urbanizationTypes = [
    {
      codPif: '1',
      nombreCorto: 'URB',
      nombre: 'URBANIZACIÓN',
      codDatacredito: '20'
    },
    {
      codPif: '2',
      nombreCorto: 'AH',
      nombre: 'ASENTAMIENTO HUMANO',
      codDatacredito: '2'
    },
    {
      codPif: '3',
      nombreCorto: 'RES',
      nombre: 'RESIDENCIAL',
      codDatacredito: '11'
    },
    {
      codPif: '4',
      nombreCorto: 'CH',
      nombre: 'CONJUNTO HABITACIONAL',
      codDatacredito: '10'
    },
    {
      codPif: '5',
      nombreCorto: 'UV',
      nombre: 'UNIDAD VECINAL',
      codDatacredito: '19'
    },
    {
      codPif: '6',
      nombreCorto: 'ASO',
      nombre: 'ASOCIACIÓN DE VIVIENDA',
      codDatacredito: '3'
    },
    {
      codPif: '7',
      nombreCorto: 'COP',
      nombre: 'COOPERATIVA DE VIVIENDA',
      codDatacredito: '12'
    },
    {
      codPif: '8',
      nombreCorto: 'AGR',
      nombre: 'AGRUPACIÓN',
      codDatacredito: '1'
    },
    {
      codPif: '9',
      nombreCorto: 'PJ',
      nombre: 'PUEBLO JOVEN',
      codDatacredito: '18'
    }
  ];
